// Click-tracking helpers. Events are pushed to the Google Tag Manager
// dataLayer, which only forwards them on the production hostnames (the GTM
// snippet in gatsby-ssr.tsx is not loaded on localhost/staging); the fallback
// array means calls never throw there.

const pushDataLayer = (event: Record<string, unknown>) => {
  const w = window as Window & { dataLayer?: Record<string, unknown>[] };
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push(event);
};

// link_location distinguishes the site's tel: links: "header", "home",
// "contact".
export const trackPhoneClick = (phoneNumber: string, linkLocation: string) =>
  pushDataLayer({
    event: "phone_click",
    phone_number: phoneNumber,
    link_location: linkLocation,
  });

export const trackBookingClick = () =>
  pushDataLayer({ event: "booking_click", link_location: "header" });
